export default __webpack_public_path__ + "static/media/Camera.44880945.mov";